import React from 'react';
import { faqs } from '../data/mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-700" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Clear answers to common questions about our process.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={`item-${faq.id}`}
              className="bg-white border border-gray-200 rounded-lg px-6 hover:border-[#FFD000] transition-all duration-300"
            >
              <AccordionTrigger className="text-left text-black hover:text-[#FFD000] py-6">
                <span className="text-lg font-normal">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 text-sm pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
